import { useCallback } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import startupCurve from 'features/views/campaignSettings/startupCurve';

const { BY_SUCCESS, BY_REPLACEMENT, BY_PLAN } = startupCurve.constants.curveType;

export const CurveTypeRadioGroup = () => {
	const dispatch = useDispatch();

	const curveType = useSelector(startupCurve.selectors.getCurveType);

	const handleCurveTypeChange = useCallback(
		(event) => {
			dispatch(startupCurve.actions.changeCurveType(event.target.value));
		},
		[dispatch],
	);

	return (
		<Paper sx={{ p: 3, borderRadius: 2 }}>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('startupCurve:display')} />
				<ComponentLoader fetchStorePath={startupCurve.constants.fetchState.get}>
					<Grid container>
						<Grid size={12}>
							<Grid container spacing={3}>
								<Grid size={4}>
									<FormControlLabel
										control={
											<Radio
												onChange={handleCurveTypeChange}
												value={BY_SUCCESS}
												checked={curveType === BY_SUCCESS}
											/>
										}
										label={getLabelMessage('startupCurve:byWorkload')}
									/>
								</Grid>
								<Grid size={4}>
									<FormControlLabel
										control={
											<Radio
												onChange={handleCurveTypeChange}
												value={BY_REPLACEMENT}
												checked={curveType === BY_REPLACEMENT}
											/>
										}
										label={getLabelMessage('startupCurve:bySubstitute')}
									/>
								</Grid>
								<Grid size={4}>
									<FormControlLabel
										control={
											<Radio
												onChange={handleCurveTypeChange}
												value={BY_PLAN}
												checked={curveType === BY_PLAN}
											/>
										}
										label={getLabelMessage('startupCurve:byPPK')}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</ComponentLoader>
			</Stack>
		</Paper>
	);
};

export default CurveTypeRadioGroup;
